import { Component, Input, OnInit } from '@angular/core';
import { BrowseComponent } from '@shared/components/browse/abstract.browse.component';
import { NzModalService } from 'ng-zorro-antd';
import { CommonsService } from '@core/service/commons.service';
import { Pagination } from '@core/bean/pagination';
import { Observable } from 'rxjs/index';
import { HttpParams } from '@angular/common/http';
import { BrowseConfig } from '@core/bean/browse-config';
import { SourceAllService } from '../../../../routes/jy-srm/procu-source/source-items/source-item-detail/source-all.service';
import {Sort} from "@core/bean/sort";
import {Direction} from "@core/bean/direction";

/**
 * 招投标类型
 */
@Component({
  selector: 'app-reference-document-browse',
  templateUrl: './reference-document.browse.component.html'
})

export class InquiryDocumentBrowseComponent implements BrowseComponent, OnInit {

  static componentName='InquiryDocumentBrowseComponent';


  @Input() config: BrowseConfig;
  @Input() onOk: (data: any | [any]) => void;
  @Input() onCancel: () => void;

  visible = false;
  formLoading = false;
  pagination: Pagination = new Pagination();
  searchData: any = {};
  constructor(private commonsService: CommonsService,
              private modalService: NzModalService,
              private aourceAllService: SourceAllService,
  ) {
    this.pagination.getData = function(params: HttpParams): Observable<any> {
      return aourceAllService.query(params);
    };
  }


  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.searchData['un-flow-search'] = 'draft';
    this.pagination.addDefaultSort(new Sort('createdDate', Direction.DESC));
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    }
  }

  selectData(data) {
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }
}

